// extracted by mini-css-extract-plugin
export default {"footer":"footer-module___footer___b99ceabe"};